import type { LoaderSize } from "./Loader.types";

export const loaderClassNames = {
  base: "Loader",
  centered: "Centered",
};

export const loaderSizeClassMap: Record<LoaderSize, string> = {
  sm: "SizeSm",
  md: "SizeMd",
  lg: "SizeLg",
  xl: "SizeXl",
};
